import { useCallback, useState } from "react";

// MUI
import { Grid } from "@mui/material";

// Helpers
import { debounceFn } from "@/Common/helpers/functions";

// Components
import SearchInput from "@Layouts/components/Basics/SearchInput";
import { SectionDepartments } from "../components/SectionDepartments";

// Types
import { IDepartment } from "@/DataPages/types/timeAndPayRates/models";

// Constants
import { DEBOUNCE_DELAY_500 } from "@/Constants/debounce";

interface IPtoContentProps {
	data: IDepartment[];
	isDataPresent: boolean;
	loading: boolean;
}

const PtoContent = (props: IPtoContentProps) => {
	const { isDataPresent, loading } = props;
	const [searchValue, setSearchValue] = useState<string>("");
	const [globalSearch, setGlobalSearch] = useState<string>("");

	const memoFn = useCallback(
		debounceFn((p: string) => setGlobalSearch(p), DEBOUNCE_DELAY_500),
		[]
	);

	const handleSearch = (value: string) => {
		setSearchValue(value);
		memoFn(value);
	};

	const shouldDisplayFlex = isDataPresent ? "flex" : "none";

	function generateKey(value: string) {
		return value.replaceAll(" ", "");
	}

	return (
		<>
			<Grid container mt={1} justifyContent={"flex-end"} display={shouldDisplayFlex}>
				<Grid item xs={3}>
					<SearchInput
						value={searchValue}
						loading={loading}
						onChange={handleSearch}
						clearSearch={() => {
							setSearchValue("");
							setGlobalSearch("");
						}}
						sx={{ display: shouldDisplayFlex }}
					/>
				</Grid>
			</Grid>

			<SectionDepartments {...props} searchValue={globalSearch} renderOption="pto" generateKey={generateKey} />
		</>
	);
};

export default PtoContent;
